import { FormControl, FormGroup } from '@angular/forms';
import { ReportFilterDto } from '../../../../../../../types/dtos/reports.dto';
import { BaseFilterStep } from '../base-filter-step';

export class FilterAlarmStep extends BaseFilterStep {

  public form: FormGroup = new FormGroup({
    status: new FormControl(),
    severity: new FormControl(),
    alarmType: new FormControl(),
  });

  getStepFilter(): ReportFilterDto {
    const {
      status,
      severity,
      alarmType
    } = this.form.value;

    return {
      filter: {
        status: status ?? undefined,
        severity: severity ?? undefined,
        alarm_type: alarmType ?? undefined
      }
    };
  }

  getForm(): FormGroup {
    return this.form;
  }
}
